import { NgModule, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { CustomersComponent } from './customers.component';
import { NbMenuItem, NbMenuService } from '@nebular/theme';
import { ViewContainersService } from '@urbannex/view-containers';
import { CustomerComponent } from './customer/customer.component';
import { CustomerCommunicationsComponent } from './customer/customer-communications/customer-communications.component';
import { OrdersComponent } from './customer/orders/orders.component';
import { QuotesComponent } from './customer/quotes/quotes.component';
import { RequestsComponent } from './customer/requests/requests.component';
import { ShoppinglistsComponent } from './shoppinglists/shoppinglists.component';
import { Subject, map, takeUntil } from 'rxjs';

export const routes:Routes = [
  {
    path:'',
    component:CustomersComponent
  },
  {
    path:'customer/:partyId',
    component:CustomerComponent
  },
  {
    path:'customer/:partyId/orders',
    component:OrdersComponent
  },
  {
    path:'customer/:partyId/requests',
    component:RequestsComponent
  },
  {
    path:'customer/:partyId/quotes',
    component:QuotesComponent
  },
  {
    path:'customer/:partyId/communications',
    component:CustomerCommunicationsComponent
  },
  {
    path:'customer/:partyId/shoppinglists',
    component:ShoppinglistsComponent
  },
  {
    path:'customer/:partyId/contactLists',
    component:CustomerComponent
  },

]

export const baseMenuItems:NbMenuItem[] = [
  {title:"Customer Relationship Management",group:true},
  {title:"List Customers",icon:"list-outline",link:"/admin/crm/customers"},
  {title:"New Customer",icon:"plus-outline"},
]

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes)
  ]
})
export class CustomerRoutingModule implements OnInit, OnDestroy{ 
  MENU_ITEMS:NbMenuItem[] = baseMenuItems;
  headerTitle:string = "CRM";
  path:string = "crm";
  menuTag:string = "partyMenu"
  menuAndTitleOptions = {path:this.path,menuItems:this.MENU_ITEMS,headerTitle:this.headerTitle,menuTag:this.menuTag};

  private destroy$ = new Subject<void>();

  contextMenu$ = this.viewContainerService.contextMenu$.pipe(
    takeUntil(this.destroy$),
    map(contextMenuItems => contextMenuItems)
  )

  constructor(
    private viewContainerService:ViewContainersService,
    private menuService:NbMenuService){
    console.log("UpdateMenuTitle",this.menuAndTitleOptions)
    this.viewContainerService.menuAndTitleOptions$.next([... this.viewContainerService.menuAndTitleOptions$.getValue(),this.menuAndTitleOptions]);
    this.viewContainerService.activeMenuTag$.next(this.menuTag);
    //this.viewContainerService.addMenuAndTitleOptions(this.menuAndTitleOptions);
    //this.menuService.addItems(baseMenuItems,"partyMenu");
  }
  ngOnInit(): void {
    this.menuService.onItemSelect().subscribe(data => console.log(data));
    this.contextMenu$.subscribe(data => {console.log(data)})
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
